import React from 'react';
import type { TagData } from '@hub/features/account-dashboard/types/tag-data.types';
import type { ChipProps } from '@mui/material';
import { Tag, Tooltip } from '@monorepo/nova-ui';
import { COMPONENT_CONFIG } from '../constants';
import { StatusDot } from '../status-dot';
import { StatusTagWrapper } from '../styled';

/**
 * Header Title Utility Functions
 */

/**
 * Renders a status tag with optional tooltip
 * @param tagData - Tag data containing status information
 * @returns JSX element with tag and optional tooltip
 */
export const renderStatusTag = (tagData: TagData) => {
  const tag = (
    <Tag
      label={tagData.status.label}
      color={tagData.status.color as ChipProps['color']}
      size={COMPONENT_CONFIG.TAG_SIZE as ChipProps['size']}
      icon={<StatusDot status={tagData.status.statusDot} />}
    />
  );

  return tagData.status.tooltip ? (
    <Tooltip title={tagData.status.tooltip}>
      <StatusTagWrapper>{tag}</StatusTagWrapper>
    </Tooltip>
  ) : (
    tag
  );
};

/**
 * Renders a standard tag component
 * @param label - Tag label text
 * @param color - Tag color
 * @returns JSX element with tag
 */
export const renderTag = (label: string, color: string) => (
  <Tag
    label={label}
    color={color as ChipProps['color']}
    size={COMPONENT_CONFIG.TAG_SIZE as ChipProps['size']}
  />
);

/**
 * Gets the display text for program name
 * @param programName - Program name from store
 * @param isLoading - Loading state
 * @returns Display text for program
 */
export const getProgramDisplayText = (
  programName?: string,
  isLoading?: boolean,
): string => {
  if (isLoading) {
    return COMPONENT_CONFIG.LOADING_TEXT;
  }
  return programName || COMPONENT_CONFIG.LOADING_TEXT;
};
